module.exports = __webpack_public_path__ + "img/compliances.ea95cf82.png";